'use client';
import { useEffect } from 'react';
import { loadAnalytics, initClickTracking } from '@/utils/analytics';

export default function DynamicAnalyticsLoader() {
  useEffect(() => {
    // Always set up click → dataLayer tracking, even if the analytics config fetch fails
    initClickTracking();
    // Defer analytics (GTM/GA/etc.) to browser idle time so it doesn't add to
    // Total Blocking Time during the critical load window.
    const ric: typeof window.requestIdleCallback | undefined = (window as any).requestIdleCallback;
    if (ric) {
      const id = ric(() => loadAnalytics(), { timeout: 4000 });
      return () => (window as any).cancelIdleCallback?.(id);
    }
    const t = setTimeout(loadAnalytics, 2500);
    return () => clearTimeout(t);
  }, []);

  return null; // This component doesn't render anything
}